import React, { useEffect, useState } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Products } from './components/Products';
import { Capacity } from './components/Capacity';
import { Quality } from './components/Quality';
import { Gallery } from './components/Gallery';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { DesktopTabs } from './components/DesktopTabs';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  const [activeTab, setActiveTab] = useState('inicio');

  useEffect(() => {
    // Set page title and meta tags
    document.title = 'GONSO - Hortalizas Frescas al Por Mayor | Honduras';
    
    // Add meta description for SEO
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'GONSO - Producción y comercialización de hortalizas frescas al por mayor en Honduras. Abastecemos supermercados, distribuidores y sector hotelero con tomate, chile y cebolla de calidad. Entregas a nivel nacional.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'GONSO - Producción y comercialización de hortalizas frescas al por mayor en Honduras. Abastecemos supermercados, distribuidores y sector hotelero con tomate, chile y cebolla de calidad. Entregas a nivel nacional.';
      document.head.appendChild(meta);
    }

    // Add keywords meta tag
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = 'hortalizas honduras, tomate por mayor, chile por mayor, cebolla por mayor, GONSO, distribuidores hortalizas, vegetales frescos honduras, abastecimiento mayorista';
      document.head.appendChild(meta);
    }
  }, []);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div className="App">
      <Header activeTab={activeTab} onTabChange={handleTabChange} />
      
      {/* Desktop Version with Tabs */}
      <main className="hidden lg:block">
        <DesktopTabs activeTab={activeTab} setActiveTab={setActiveTab} />
      </main>

      {/* Mobile Version with Scroll */}
      <main className="lg:hidden">
        <div id="inicio">
          <Hero />
          <About />
        </div>
        <Products />
        <Capacity />
        <Quality />
        <Gallery />
        <Contact />
      </main>

      <Footer />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
